import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { BlogPostSummary } from "../../redux/features/blog/blog.types";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { formatDate } from "../../utils/helpers";
import { urlForImage } from "../../utils/sanityClient";

export const BlogCard = ({ post }: { post: BlogPostSummary }) => {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex w-full flex-col-reverse items-start gap-6 md:flex-row md:gap-[140px]"
    >
      <div className="flex flex-1 flex-col justify-center gap-6">
        <p className="font-onest text-[16px] font-normal leading-[28px] tracking-[-0.32px] text-grey-800">
          {post.category?.title}
          {post.category?.title ? " ∙ " : ""}
          {formatDate(post.publishedAt, "MMM D, YYYY", true)}
        </p>

        <div className="flex flex-col gap-3">
          <p className="font-dela text-[28px] leading-[30px] tracking-[-0.56px] text-ink md:text-[40px] md:leading-[42px] md:tracking-[-0.8px]">
            {post.title}
          </p>

          {post.excerpt ? (
            <p className="font-onest text-[20px] font-normal leading-[28px] tracking-[-0.4px] text-grey-800">
              {post.excerpt}
            </p>
          ) : undefined}
        </div>
      </div>

      {post.mainImage ? (
        <div className="h-[220px] w-full shrink-0 overflow-hidden rounded-[8px] md:h-[260px] md:w-[462px]">
          <img
            src={urlForImage(post.mainImage).width(924).height(520).fit("crop").url()}
            alt={post.mainImage.alt || post.title}
            className="h-full w-full object-cover transition-all duration-500 group-hover:scale-105"
          />
        </div>
      ) : undefined}
    </Link>
  );
};

export const BlogCardLoader = () => {
  return (
    <div className="flex w-full flex-col-reverse items-start gap-6 md:flex-row md:gap-[140px]">
      <div className="flex flex-1 flex-col justify-center gap-6">
        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={160}
          height={20}
        />

        <div className="flex flex-col gap-3">
          <Skeleton
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            baseColor={SKELETON_BASE_COLOR}
            width={"100%"}
            height={70}
            className="rounded-xl"
          />
          <Skeleton
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            baseColor={SKELETON_BASE_COLOR}
            width={"90%"}
            height={48}
            className="rounded-xl"
          />
        </div>
      </div>

      <Skeleton
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        baseColor={SKELETON_BASE_COLOR}
        width={"100%"}
        height={260}
        className="!block w-full rounded-[8px] md:!w-[462px]"
      />
    </div>
  );
};
